import React from 'react';
import { Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/Button';

interface SettingsPreferencesProps {
  user: any;
  setShowConfirmClear: (val: boolean) => void;
  setShowConfirmDelete: (val: boolean) => void;
}

export function SettingsPreferences({ user, setShowConfirmClear, setShowConfirmDelete }: SettingsPreferencesProps) {
  return (
    <>
      <section>
        <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-3">Local History</h3>
        <div className="bg-slate-50 dark:bg-slate-900/50 p-4 rounded-xl border border-slate-100 dark:border-slate-800">
          <p className="text-slate-600 dark:text-slate-400 mb-4 text-xs">
            Your resume history and job descriptions are stored locally on this device. You can clear this data at any time.
          </p>
          <Button 
            variant="secondary"
            size="sm"
            onClick={() => setShowConfirmClear(true)}
            className="gap-2"
          >
            <Trash2 className="w-4 h-4" />
            Clear Local History
          </Button>
        </div>
      </section>

      {user && (
        <section>
          <h3 className="text-lg font-bold text-red-600 dark:text-red-500 mb-3">Danger Zone</h3>
          <div className="bg-red-50 dark:bg-red-950/20 p-4 rounded-xl border border-red-200 dark:border-red-900/30">
            <p className="text-red-800 dark:text-red-400 mb-4 text-xs max-w-[90%]">
              Permanently delete your account and all associated data from our servers. This action is irreversible.
            </p>
            <Button 
              variant="danger"
              size="sm"
              onClick={() => setShowConfirmDelete(true)}
              className="gap-2"
            >
              <Trash2 className="w-4 h-4" />
              Delete Account
            </Button>
          </div>
        </section>
      )}
    </>
  );
}
